// Guide onboarding checklist
export const GUIDES_AND_SURVEYS_KEYS = {
  ONBOARDING_CHECKLIST: 'guide-onboarding-checklist',
};

export const GUIDES_AND_SURVEYS_CALLBACK_KEYS = {
  CHECKLIST_ITEM_COMPLETED: 'checklist-item-completed',
};
